<template>
  <div class="storepurchase_Wrapper">
   <Qrcode-Dialog :instockdia.sync="instockdia" :maincusCode="maincusCode"/>

   <el-dialog :title="$t('other.a2450')"  :visible.sync="dialogTableVisibleTwo" width="40%">
			<el-table :data="bindItemList02" height="450px" >
				<el-table-column width="80" :label="$t('other.a66')" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-popover placement="top-start" title="" trigger="hover">
							<img :src="scope.row.image" alt="" style="width: 150px;height: 150px">
							<img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column width="200" :label="$t('other.a67')" :show-overflow-tooltip="true">
					<template slot-scope="scope" >
						<!-- <el-input v-model="scope.row.cusCode" ></el-input> -->
						<span>{{scope.row.cusCode}}</span>
					</template>
				</el-table-column>
				<el-table-column  label="sku" :show-overflow-tooltip="true">
					<template slot-scope="scope" >
						<!-- <el-input v-model="scope.row.skuName" ></el-input> -->
						<span>{{scope.row.skuName}}</span>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('other.a2452')" >
					<template slot-scope="scope" >
						<span>{{scope.row.rate}}</span>
					</template>
				</el-table-column>
				
			</el-table>
		</el-dialog>
    <div class="header_top">
      <!-- 一级菜单栏 -->
      <div class="query_list">
        <div style="width: 150px">
          <el-select
            @change="getStoreItemAndGroup()"
            v-model="warehouseId"
            :placeholder="$t('other.a914')"
          >
            <el-option
              v-for="item in warehouseOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div style="width: 150px;margin: 0 5px">
          <el-select
            @change="getStoreItemAndGroup()"
            v-model="SelllerValue"
            :placeholder="$t('other.a1558')"
          >
            <el-option
              v-for="item in sellerList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="query-list-bbc create">
          <el-input
            style="width: 320px; margin: 0 5px"
            clearable
            :placeholder="$t('other.a1327')"
            v-model="cusCode"
          ></el-input>
          <el-button type="primary" @click="getStoreItemAndGroup()">{{
            $t("userStoreItems").search
          }}</el-button>
        </div>
        <div>
          <el-button
          style="margin-left: 15px"
          type="primary"
          @click="isExtened = !isExtened"
          >{{ isExtened ? $t('other.a2690') : $t('other.a2691') }}</el-button
        >
        </div>
      </div>
    </div>
    <!-- 产品展示列表 -->
    <div class="goodsArea">
      <div class="my-goods-data">
        <div
          class="list-item"
          v-for="(outeritem, indexOne) in newUserstoreItem"
          :key="indexOne"
        >
          <div style="border-bottom: 1px solid #e0e0e0">
            <div class="outPsku">
              <div class="outPsku_left">
                <span style="color: red; font-size: 18px; margin-left: 15px">
                  {{$t('other.a2145')}}：</span
                >
                <span
                  style="color: red; font-size: 18px"
                  v-show="!outeritem.checked01"
                  >{{ outeritem.itemSku }}</span
                >
              </div>
              <div class="outPsku_right">
                <el-button
                  style="margin-left:20px;min-width:160px;"
                  type="primary"
                  @click="outeritem.checked02 = !outeritem.checked02"
                  >{{$t('other.a2146')}}/{{$t('other.a2147')}}</el-button
                >
              </div>
            </div>

            <div class="outDesc">
              <div style="display: flex">
                <div class="goods-pic">
                  <img
                    v-image-preview
                    :src="
                      outeritem.image
                        ? outeritem.image
                        : outeritem.storeItems
                        ? outeritem.storeItems[0].image
                        : ''
                    "
                  />
                  <span class="fixPic" @click="changePic(outeritem.groupId, 0)"
                    >{{$t('other.a2692')}}</span
                  >
                </div>
                <div style="width: 300px; margin-left: 20px">
                  {{
                    outeritem.storeItems
                      ? outeritem.storeItems[0].itemName
                      : " "
                  }}
                </div>
                <div style="width: 180px; margin-left: 20px; text-align: left">
                  <div>
                    {{$t('other.a2149')}}：{{
                      outeritem.storeItems ? outeritem.storeItems.length : 0
                    }}
                  </div>
                  <div>{{$t('other.a2150')}}：{{ outeritem.qytInStore }}</div>
                  <div>{{$t('other.a2693')}}：{{ outeritem.userId }}</div>
                </div>
               
              </div>
            </div>
          </div>
          <div
            v-show="!outeritem.checked02"
            class="childrenItem"
            v-for="(item, index) in outeritem.storeItems
              ? outeritem.storeItems
              : []"
            :key="index"
          >
            <div class="goods-title-desc-wrapper">
              <div class="check_And_Img">
                <div
                  style="
                    width: 40px;
                    height: 40px;
                    margin: 20px 10px 0 0;
                    position: relative;
                  "
                >
                  <img v-image-preview width="100%" :src="item.image" />
                  
                </div>
                <div class="goods-title-desc-box">
                  <div
                    style="font-size: 16px; padding-bottom: 5px"
                    
                  >
                    {{$t('other.a2139')}}：{{ item.skuName }}
                  </div>
                  

                  <div
                    style="font-size: 16px; padding-bottom: 5px"
                   
                  >
                    skuName：{{ item.variationName }}
                  </div>
                  
                  <div class="goods-item-a">
                    {{ $t("userStoreItems").cusCode }}：{{ item.cusCode }}
                  </div>
                  <div class="goods-item-a"></div>
                </div>
              </div>

              <div class="goods-title-desc">
                <div class="goods-item-a">
                  {{ $t("userStoreItems.Quantitytobeshipped") }}：{{
                    item.auditedStock
                  }}
                </div>
                <div class="goods-item-a">
                  {{ $t("userStoreItems").shipping_stock }}：{{
                    item.unShipped
                  }}
                </div>

                <div class="goods-item-a">
                  <span  >{{$t('userStoreItems').total_stock}}：{{item.storeNum}}</span>
                </div>
                <div v-show="item.independent" class="goods-item-a">
                  <span  v-show="!item.checked_one">{{$t('other.a2694')}}：{{item.separateNum}}</span>
                  <span  v-show="item.checked_one">{{$t('other.a2694')}}：<input style="width: 50px;" size="mini" v-model="item.separateNum" /></span>
                  <i  style="margin-left: 15px;color: #409EFF;font-size: 16px;cursor: pointer;" v-show="!item.checked_one "  @click="changeStock(outeritem,item,indexOne,index)" class="el-icon-edit " ></i>
                  <el-button style="margin-left: 15px;" v-show="item.checked_one"  @click="changeIndependentStock(outeritem,item,indexOne,index)" size="mini" type="danger">{{$t('other.a145')}}</el-button>
                </div>
              </div>
              <div class="goods-title-desc bbp">
                <div class="goods-item-a">
                  <div>{{$t('other.a2153')}}：
                    <span></span>
                   
                    <span >  {{ item.packageLength ? item.packageLength : 0 }}</span>
                    <!-- <input v-show="item.checked" style="width: 50px;padding:0px" v-model="item.packageLength"> -->
                    ({{$t('other.a1255')}})x
                    <span >  {{ item.packageWidth ? item.packageWidth : 0 }}</span>
                    <!-- <input v-show="item.checked" style="width: 50px;padding:0px" v-model="item.packageWidth"> -->
                     
                     ({{$t('other.a1256')}}) x
                    <span >  {{ item.packageHeight ? item.packageHeight : 0 }}</span>
                    <!-- <input v-show="item.checked" style="width: 50px;padding:0px" v-model="item.packageHeight"> -->
                    
                    ({{$t('other.a1257')}}) cm
                  </div>
                </div>
                <div class="goods-item-a">
                  <div>
                    {{ $t("userStoreItems.weight") }}：
                    <span > {{item.weight ? item.weight : 0}}</span>
                    <!-- <input v-show="item.checked" style="width: 50px;padding:0px" v-model="item.weight"> -->
                    kg
                  </div>
                 
                </div>
                <div class="goods-item-a">
                  <div>{{$t('other.a1169')}}：
                     <span v-show="!item.checked"> {{ item.address ? item.address : $t('other.a354') }}</span>
                     <input v-show="item.checked" style="width: 50px;padding:0px" v-model="item.address">
                     <i  style="margin-left: 15px;color: #409EFF;font-size: 16px;cursor: pointer;" v-show="!item.checked && item.independent"  @click="editor(outeritem,item,indexOne,index)" class="el-icon-edit " ></i>
                     <el-button style="margin-left: 15px;" v-show="item.checked"  @click="editor(outeritem,item,indexOne,index)" size="mini" type="danger">{{$t('other.a145')}}</el-button>

                  </div>
                </div>
              </div>

              <div class="btn-wrapper">
                <div class="btn-item-desc">
                  <el-button
                    style="min-width: 160px"
                    type="primary"
                    size="medium"
                    @click.stop="opendialogTableVisibleTwo(item)"
                    >{{$t('other.a2695')}}(x {{item.children.length}})</el-button
                  >
                </div>
                 <!-- <div class="btn-item-desc">
                  <el-button
                    style="min-width: 160px"
                    :type="item.checked ? 'danger' : 'primary'"
                    size="medium"
                    @click="editor(outeritem,item,indexOne,index)"
                   
                    >{{item.checked ? $t('other.a2696') : $t('other.a2697')}}</el-button
                  >
                </div> -->
                <div class="btn-item-desc">
                  <el-button
                    style="min-width: 160px"
                    type="primary"
                    size="medium"
                    @click.stop="viewstoreoperaterecord(item)"
                    >{{$t('other.a2558')}}</el-button
                  >
                </div>
               
              </div>
            </div>
          </div>
        </div>
        <!-- 分页器 -->
        <div class="Pager">
          <el-pagination
            @size-change="handleSizeChangeTwo"
            @current-change="handleCurrentChangeTwo"
            :current-page="currentPage"
            :page-sizes="[15, 20, 30, 100]"
            :page-size="15"
            layout="total, sizes, prev, pager, next, jumper"
            :total="itemsCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import userStoreItems from "../../api/moudles/userStoreItems";
import QrcodeDialog from '../../components/dialog/qrcodeDialog.vue'
import utils from '../../utils/utils'
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {

      warehouseId: null,
      warehouseOption: null,
      TitleDesc: "",
      handleParam: null,
      cusCode: "",
      newUserstoreItem: [],
      offset: 15,
      instockdia:false,
      getDataList: null,
      page: 0,
      checkedAll: false,
      targetList: [],
      isExtened: true,
      maincusCode:0,
      isEdit: -1,
      SelllerValue:'all',
      sellerList:[],
      dialogTableVisibleTwo: false,
      additionParents: [],
      isShow: false,
      isEditGoods: false,
      multipleSelection: [],
      additionItem: null,
      bindItemList02:[],
      itemsCount:0,
      currentPage:1,
      page: 0,
      value: null,
      instockdia:false,
      maincusCode:null
     
    };
  },
  components: {
    QrcodeDialog,
  },
  computed: {
    ...mapState({
      userId: (state) => state.shopaccess.userInfo.userId,
      userName: (state) => state.shopaccess.userInfo.userName,
    }),
  },
  watch: {
    
    isExtened() {
      if (this.isExtened) {
        this.newUserstoreItem.forEach((p) => {
          p.checked02 = true;
        });
      } else {
        this.newUserstoreItem.forEach((p) => {
          p.checked02 = false;
        });
      }
    },
  },

  created() {
    this.warehouseOption = JSON.parse(
      localStorage.getItem("userInfo")
    ).stores.map((p) => {
      return {
        label: p.storeName,
        value: p.storeId,
      };
    });
    this.warehouseId = this.warehouseOption[0].value;

    this.sellerList=JSON.parse(localStorage.getItem('userInfo')).sellers.map(p => {
        return {
          label:p.userName,
          value:p.userId
        }
      })

      this.sellerList.unshift({
        label:this.$t('other.a1571'),
        value:'all'
      })

    this.getStoreItemAndGroup();
    console.log(this.warehouseId);
  },
  methods: {
  

    ...mapActions("userStoreItems", [
      "updateGroup",
      "sellerUpdateStoreItemDetail",
      'getInstockoperaterecore',
      'deleStoreItems',
      'storeUpdateStoreNumAndAddress',
      'updateStoreNumBystore',
      'getInstockoperaterecore'
    ]),


    	opendialogTableVisibleTwo(item){
				this.isComponent=item.component
				console.log(item)
				this.cuscodeBand=item.cusCode
				this.bindItemList01=item.items
				this.bindItemList02=item.component ? item.parents :  item.children
				this.dialogTableVisibleTwo=true
			},


    viewstoreoperaterecord(item){
				this.instockdia=true
				this.maincusCode=item.cusCode
				let params={
					cusCode:item.cusCode,
					end:utils.CurdateAddoneday(utils.getRecentDays(0)),
					start:utils.getRecentDays(-7),
					offset:50,
					page:0,
					userId:this.userId
				}
				console.log(params)
				this.getInstockoperaterecore(params)
			},


    editor(outeritem,item,indexOne,index){
      console.log(outeritem,item,indexOne,index)
      item.userId=this.userId
      this.newUserstoreItem[indexOne].storeItems[index].checked=!this.newUserstoreItem[indexOne].storeItems[index].checked

      if(!this.newUserstoreItem[indexOne].storeItems[index].checked){
        
        this.storeUpdateStoreNumAndAddress(item)
      }else{
        
      }

    },

    changeStock(outeritem,item,indexOne,index){
      console.log(outeritem,item,indexOne,index)
      item.userId=this.userId
      this.newUserstoreItem[indexOne].storeItems[index].checked_one=!this.newUserstoreItem[indexOne].storeItems[index].checked_one

      if(!this.newUserstoreItem[indexOne].storeItems[index].checked_one){
        let params={
						cusCode:item.cusCode,
						storeNum:Number(item.storeNum),
					}
					console.log(params)
					this.updateStoreNumBystore(params)
        
      }else{
        
      }

    },

    changeIndependentStock(outeritem,item,indexOne,index){
      console.log(outeritem,item,indexOne,index)
      item.userId=this.userId
      this.newUserstoreItem[indexOne].storeItems[index].checked_one=!this.newUserstoreItem[indexOne].storeItems[index].checked_one

      if(!this.newUserstoreItem[indexOne].storeItems[index].checked_one){
        let params={
						cusCode:item.cusCode,
						storeNum:Number(item.separateNum),
					}
					
          userStoreItems
          .updateSeparateNum(params)
          .then(res => {
            if(res.code === 200){
              this.$message.success(this.$t('other.a665'))
            }
          })
					
        
      }else{
        
      }

    },



    getStoreItemAndGroup() {
    this.getDataList = {
      offset: this.offset,
      page: this.page,
      userId: this.userId,
      storeId: this.warehouseId,
      sellerId:this.SelllerValue == 'all'? '' : this.SelllerValue,
      addition: false,
      component: false,
      cusCode: this.cusCode,
     
    },

    //获取页面赠品的数据
    userStoreItems.getStoreItem(this.getDataList).then((res) => {
        if (res.code === 200) {
          console.log("赠品item", res.data);
          this.itemsCount=res.data.count
            this.newUserstoreItem=[]
          if(!res.data.groups.length){
            this.newUserstoreItem=[]
            return
          }
          res.data.groups.forEach((p) => {
             p.checked02=true
             p.qytInStore=0
            p.storeItems.forEach((k) => {
              p.qytInStore+=k.storeNum
              k.checked = false;
              k.checked_one = false;
            });
            this.newUserstoreItem.push(p);
          });
        }
      });
    },

    //控制每页显示订单条数
    handleSizeChangeTwo(val) {
      console.log(`每页 ${val} 条`);
      this.offset = parseInt(`${val}`);
      this.handleCurrentChangeTwo();
    },
    //显示当前第几页
    handleCurrentChangeTwo(val) {
      this.currentPage = parseInt(`${val}`);
      this.page =`${val}` == "undefined" ? 0 : (parseInt(`${val}`) - 1) * this.offset;
      this.getStoreItemAndGroup();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.storepurchase_Wrapper {
  margin-top: 70px;

  .Pager{
    position: fixed;
		bottom: 0;
		left: 225px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	
  }

  /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    width: 4px;
    font-weight: bold;
  }

  .header_top {
    position: fixed;
    width: 100%;
    top: 130px;
    background-color: #fff;
    z-index: 9;
    padding: 0 10px;
    border-bottom: 1px solid #eee;

    .query-list-tcp {
      padding: 10px 0 20px 0;
    }
    .query_list {
      padding: 10px 0 20px 0;
      @include flex-start();
    }
  }

  .goodsArea {
    margin-top: 148px;
    margin-bottom: 120px;
  }

  .list-item {
    margin: 0 10px 0 0;
    box-sizing: border-box;
    padding: 8px ;
    margin-bottom: 10px;
    box-shadow:#909399 1px 2px 10px;

    .childrenItem {
      padding: 10px 0 5px 25px;
      border-bottom: 1px solid #eee;

      .goods-title-desc-wrapper {
        @include flex-between();

        .check_And_Img {
          display: flex;
          width: 350px
        }
      }
    }

    .outPsku {
      @include flex-between();
      align-items: center;
      box-sizing: border-box;
      padding: 3px 0;
      border-bottom: 1px solid #eee;

      .outPsku_left {
        display: flex;
        align-items: center;

        .el-input {
          width: 300px;
        }

        .el-icon-edit {
          margin-left: 15px;
          cursor: pointer;
          color: #409eff;
          font-size: 18px;
        }
      }

      .outPsku_right {
        display: flex;
        align-items: center;
      }
    }

    .btn-item-desc {
      padding: 0 0 8px 0;
    }

    .outDesc {
      @include flex-between();
      box-sizing: border-box;
      padding: 10px 0;

      .goods-pic {
        width: 60px;
        height: 60px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>